module.exports = __webpack_public_path__ + "img/laporan-dark.ceb438b1.svg";